import { Component, ElementRef, Inject, ViewChild, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { LoadingButtonComponent } from '../../shared/loading-button/button';

declare let $: any;

@Component({
    selector: 'app-share-to-email',
    templateUrl: 'share-to-email.component.html',
    styleUrls: ['share-to-email.component.css']
})
export class ShareToEmailComponent implements OnInit {
    user: any;
    error: any;
    list_email = [];
    sending = false;
    @ViewChild('sendbutton') sendbutton: LoadingButtonComponent;
    @ViewChild('text') text: ElementRef;
    @ViewChild('message') textarea: ElementRef;
    constructor(private dialogRef: MatDialogRef<ShareToEmailComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, private service: IdexService) {
        this.user = this.service.user;
        if (this.data.list_people.length !== 0) {
            this.data.list_people.forEach(people => {
                if (people.type  ===  'USER') {
                  this.list_email.push(people.id);
               }
            });
        }
    }


    ngOnInit() {
        if (this.list_email.length !== 0) {
            $('#placeholder_div').remove();
        }
    }

    send(message: any, button: any) {
        if (this.list_email.length > 0) {
            this.error = '';
            button.disabled = true;
            this.text.nativeElement.readOnly = true;
            this.textarea.nativeElement.readOnly = true;
            this.sending = true;
            this.service.share_sendEmail(this.data.shareId, this.list_email, message.value)
                .subscribe(data => {
                    this.sendbutton.reset();
                    this.dialogRef.close(true);
                }, error => {
                    button.disabled = false;
                    this.sending = false;
                    this.text.nativeElement.readOnly = false;
                    this.textarea.nativeElement.readOnly = false;
                    this.sendbutton.reset();
                });
        } else {
            this.sendbutton.reset();
            this.data.translate.get('alert.valid_email').subscribe(s => {
                this.error = s;
            });
        }

    }
    focus() {
        $('#placeholder_div').remove();
        $('#textArea').show();
        $('#textArea').focus();
    }
    onblur(item: any) {
        if (item.value.trim() === '') {
            if ($('#divEditor')[0].childNodes.length === 0 || $('#divEditor').find($('div')).length === 0) {
                if (window.localStorage.getItem('lang') === 'en') {
                    $('#divEditor').append('<div id="placeholder_div">' + 'Enter email addresses...' + '</div>');
                } else {
                    $('#divEditor').append('<div id="placeholder_div">' + 'กรอกอีเมล' + '</div>');
                }
                this.error = '';
                $('#textArea').hide();
            } else {
                $('#textArea').hide();
            }
        } else {
            const text = item.value.trim();
            const len = $('#divEditor')[0].childNodes.length;
            const reg = /^[_A-Za-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
            if (text !== '' && reg.test(text)) {
                this.error = '';
                this.list_email.push(text.toLowerCase());
                $('#textArea').val('');
            } else {
                this.data.translate.get('alert.invalid_email').subscribe(s => {
                    this.error = s;
                });
            }
        }
    }
    handleKeyDown(event: KeyboardEvent, item: any) {
        if (event.key === ' ' || event.key === ';' || event.key === ',' || event.key === 'Enter') {
            event.preventDefault();
            if (item.value.trim() === '') {
                if ($('#divEditor')[0].childNodes.length === 0 && $('#divEditor').find($('div')).length === 0) {
                    if (window.localStorage.getItem('lang') === 'en') {
                        $('#divEditor').append('<div id="placeholder_div">' + 'Enter email addresses...' + '</div>');
                    } else {
                        $('#divEditor').append('<div id="placeholder_div">' + 'กรอกอีเมล' + '</div>');
                    }
                    this.error = '';
                }
            } else {
                const text = item.value.trim();
                const len = $('#divEditor')[0].childNodes.length;
                const reg = /^[_A-Za-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
                this.error = '';
                if (text !== '' && reg.test(text)) {
                    this.list_email.push(text.toLowerCase());
                    $('#textArea').val('');
                } else {
                    this.data.translate.get('alert.invalid_email').subscribe(s => {
                        this.error = s;
                    });
                }
            }
        } else if (event.key === 'Backspace') {
            if (item.value.trim() === '') {
                event.preventDefault();
                if (this.list_email.length > 0) {
                    this.list_email.pop();
                }
            }
        }
    }

    handleKeyPress(input: any) {
        input.style.width = ((input.value.length + 1) * 8) + 1 + 'px';
    }

    deleteEmail(email: any) {
        const i = this.list_email.indexOf(email);
        if (i !== -1) {
            this.list_email.splice(i, 1);
        }
    }
}
